import { render, staticRenderFns } from "./SdsTablePseudoScrollBar.vue?vue&type=template&id=20f63174&scoped=true"
import script from "./SdsTablePseudoScrollBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SdsTablePseudoScrollBar.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SdsTablePseudoScrollBar.vue?vue&type=style&index=0&id=20f63174&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f63174",
  null
  
)

export default component.exports